import { useEffect } from "react";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter } from "../../../shared/utility";

import { useParams } from "react-router-dom";

import { TenantDetailsViewModel } from "../../../viewmodels/setup/tenants/TenantDetailsViewModel";
import TenantDetailsForm from "../../../components/forms/tenant/TenantDetailsForm";

function TenantDetails(props) {
  const { logout } = props;
  const { tenantId } = useParams();

  const {
    createTenant,
    updateTenant,
    getTenant,
    tenant,
    loading,
  } = TenantDetailsViewModel(logout, tenantId);

  useEffect(() => {
    if (tenantId) {
      getTenant();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8 space-y-4">

      <div className="card-custom">
        {loading ? null : (
          <TenantDetailsForm
            isEdit={Boolean(tenantId)}
            actionCall={(values) => {
              if (tenantId) {
                updateTenant(values);
              } else {
                createTenant(values);
              }
            }}
            tenant={tenant}
          />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TenantDetails)
);
